import { FiGithub, FiGlobe, FiLinkedin, FiTwitter, FiYoutube } from 'react-icons/fi';
import AppFooterCopyright from './AppFooterCopyright';

const socialLinks = [
  { id: 1, icon: <FiGlobe />, url: 'https://carenthusiastkenya.co.ke/' },
  { id: 2, icon: <FiGithub />, url: 'https://github.com/kangzy-fix' },
  { id: 3, icon: <FiTwitter />, url: 'https://twitter.com/kangzy_Fix' },
  { id: 4, icon: <FiLinkedin />, url: 'https://www.linkedin.com/in/ian-kangacha-56101b245/' },
  { id: 5, icon: <FiYoutube />, url: 'https://www.youtube.com/channel/UCuLsrchaKYWvMc4WKhd7MSQ' },
];

const AppFooter = () => {
  return (
    <footer className="container mx-auto pb-12">
      <div className="mt-16 sm:mt-24 glass-panel rounded-[2rem] p-10 md:p-14 relative overflow-hidden">
        <div className="absolute top-0 right-1/4 w-[300px] h-[300px] bg-gradient-to-tl from-[#00F0FF]/10 to-transparent rounded-full blur-3xl -z-10 transform translate-y-1/2"></div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center relative z-10">
          <div>
            <p className="inline-block px-4 py-1.5 rounded-full border border-black/10 dark:border-white/10 bg-white/5 dark:bg-black/20 text-xs uppercase tracking-widest text-[#0f766e] dark:text-[#D4F06B] font-general-semibold mb-6">
              Let&apos;s Build
            </p>
            <h2 className="mt-2 font-general-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-slate-900 dark:text-white leading-[1.1]">Ready to ship your next product?</h2>
            <p className="mt-6 text-lg sm:text-xl text-slate-600 dark:text-slate-300 max-w-xl leading-relaxed font-general-regular">
              Open to high-impact builds, redesigns, and architecture upgrades for teams that demand
              world-class quality and unparalleled speed.
            </p>
          </div>

          <ul className="flex flex-wrap lg:justify-end gap-4">
            {socialLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-14 h-14 text-slate-600 hover:text-[#0f766e] dark:text-slate-300 dark:hover:text-[#D4F06B] hover:-translate-y-1 cursor-pointer rounded-full border border-black/5 dark:border-white/10 bg-white/50 dark:bg-black/40 backdrop-blur-md shadow-lg transition-all duration-300"
                  aria-label="Open social profile"
                >
                  <span className="text-xl sm:text-2xl">{link.icon}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-12 md:mt-16 border-t border-black/5 dark:border-white/10 pt-8 flex items-center justify-center relative z-10">
          <AppFooterCopyright />
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
